var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{on:{"change":_vm.picked}},_vm._l((_vm.fonts),function(font,index){return _c('option',{key:index,style:({fontFamily:font})},[_vm._v(_vm._s(font))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }